import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { ColorTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { VetGroup } from './vet-group';
import { VetGroupDetailsDialogComponent } from './vet-group-details-dialog/vet-group-details-dialog.component';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-vet-group',
    templateUrl: './vet-group.component.html',
    styleUrls: ['./vet-group.component.scss'],
})
export class VetGroupComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly messageService: MessageService,
        private readonly api: KieneTableService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Tierarztgruppen';
        this.tableDescriptor.uniqueIdentifier = 'Tierarztgruppen';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'tierarztgruppe/';
        this.tableDescriptor.searchPlaceholder = 'Tierarztgruppen durchsuchen';
        this.tableDescriptor.columns.push(new TableColumn('bezeichnung', 'Tierarztgruppe'));
        this.tableDescriptor.columns.push(new ColorTableColumn('hintergrundfarbe', 'Farbe'));

        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.showDetailsVoid = this.openDetailsDialog.bind(this);

        this.tableDescriptor.permissionCreate = 1262;
        this.tableDescriptor.permissionView = 1261;

        this.tableDescriptor.options.push(
            new TableOption(this.openDeleteConfirmDialog.bind(this), 'löschen', 'delete', 1264),
        );

        this.tableDescriptor.initialSortColumn = 'bezeichnung';
        this.tableDescriptor.initialSortDirection = 'asc';
        this.tableDescriptor.addVoid = this.openDetailsDialog.bind(this);
    }

    openDeleteConfirmDialog(vetGroup: VetGroup) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '350px',
            data: {
                title: 'Tierarztgruppe löschen',
                text: 'Wollen Sie die Tierarztgruppe ' + vetGroup.bezeichnung + ' wirklich löschen?',
                textButton: 'Löschen',
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.deleteVetGroup(vetGroup);
            }
        });
    }

    deleteVetGroup(vetGroup: VetGroup) {
        this.api.deleteEntity(this.apiBaseUrl + 'tierarztgruppe/delete.php', vetGroup).subscribe(
            () => {
                this.messageService.infoMessage('Tierarztgruppe ' + vetGroup.bezeichnung + ' erfolgreich entfernt!');
                this.api.reload();
            },
            error => {
                console.error(error);
                this.messageService.errorMessage(
                    'Löschen von Tierarztgruppe ' + vetGroup.bezeichnung + ' ist fehlgeschlagen!',
                    error,
                );
            },
        );
    }

    private openDetailsDialog(vetgroup?: VetGroup) {
        if (!vetgroup) {
            vetgroup = new VetGroup();
        }
        const dialogRef = this.dialog.open(VetGroupDetailsDialogComponent, { data: vetgroup });
        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result) {
                    this.api.reload();
                }
            },
        });
    }
}
